@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.headingContainer {
  margin-bottom: 10px;

  &.level1 {
    margin-bottom: 30px;
  }
  strong {
    font-weight: inherit;
  }
}

.ul {
  margin-top: 5px;

  &.depth1 {
    padding-left: 20px;

    .li {
      list-style-type: disc;
    }
  }
}

.li {
  margin-bottom: 5px;
}

.paragraph {
  [data-nextgen-chat='on'] [data-role='user'] & {
    display: flex;
    padding-bottom: 1px;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
}

.hr {
  margin: 10px 0;
}
